import React from "react";
import DAWProvider from "./DAWProvider";
import DAWSessionProvider from "./DAWSessionProvider";
import DAWToolbar from "./DAWToolbar";
import TransportControls from "./TransportControls";
import Arrangement from "./Arrangement";
import BottomPanel from "./BottomPanel";
import CollabPanel from "./CollabPanel";
import "./index.scss";

export default function DAW({ socket, channelName, isHost, userId, sessionMode }) {
  const sessionRole = sessionMode
    ? (isHost ? "host" : "viewer")
    : null;

  const content = (
    <DAWProvider sessionRole={sessionRole}>
      <div className={`daw-page${sessionMode ? " daw-page--session" : ""}${sessionRole === "viewer" ? " daw-page--readonly" : ""}`}>
        {sessionMode && (
          <div className="daw-session-badge">LIVE SESSION</div>
        )}
        <DAWToolbar />
        <TransportControls />
        <Arrangement />
        <BottomPanel />
        {sessionMode && (
          <CollabPanel />
        )}
      </div>
    </DAWProvider>
  );

  if (sessionMode && socket) {
    return (
      <DAWSessionProvider
        socket={socket}
        channelName={channelName}
        isHost={isHost}
        userId={userId}
      >
        {content}
      </DAWSessionProvider>
    );
  }

  return content;
}
